import React, { useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";
import INT from "../images/INT_new.png";
import addCercle from "../images/add-circle.png";
import ShareImg from "../images/share.png";
import Lock from "../images/lock.png";
import Folder from "../images/folder.png";
import TagCross from "../images/tag-cross.png";
import TagCrossGray from "../images/tag-cross-gray.png";
import { useHistory } from "react-router-dom";
import { PiTagSimple } from "react-icons/pi";
import { useQuery } from "@tanstack/react-query";
import { ApiCallGateway } from "../Network/apiCallGateway";
import { PiTagSimpleFill } from "react-icons/pi";
import {
  AiOutlineMenuFold,
  AiOutlineMenuUnfold,
} from "react-icons/ai";
import { FiPlusCircle, FiMinusCircle } from "react-icons/fi";
import { MdPassword, MdFolderCopy } from "react-icons/md";
import { DataContext } from "../context/DataContext";
import { HiMiniUsers } from "react-icons/hi2";
import { AiOutlineAudit } from "react-icons/ai";

function SidebarComponent() {
  const {
    setFolderDetails,
    setIsShared,
    adminViewUser,
    setBrudCrumb,
    sidebarSelected,
    setSidebarSelected,
  } = useContext(DataContext);

  const history = useHistory();

  const userData = JSON.parse(localStorage.getItem("loggedInUser"));

  const [open, setOpen] = useState(false);
  const [menuOpen1, setMenuOpen1] = useState(false);
  const [menuOpen2, setMenuOpen2] = useState(false);

  const logout = async () => {
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("permissions");
    Cookies.remove("access_token");
    localStorage.clear();
    window.location.reload();
  };

  const sideOpen = () => {
    setOpen((current) => !current);
    document.querySelector("body").classList.toggle("noSidebar");
  };

  const menuToggle1 = () => {
    setMenuOpen1((current) => !current);
  };
  const menuToggle2 = () => {
    setMenuOpen2((current) => !current);
  };

  const {
    isLoading,
    error,
    data: folderList,
    refetch,
  } = useQuery({
    queryKey: ["folderList"],
    queryFn: async () => {
      const res = await ApiCallGateway.folder.getAllFolders(
        1,
        adminViewUser?._id
      );
      if (res?.status === 200) {
        return res?.data;
      } else {
        return [];
      }
    },
  });
  useEffect(() => {
    refetch();
  }, [adminViewUser]);
  return (
    <div
      className={
        open ? "sidebar sidebar-close" : "sidebar sidebar-open"
      }
    >
      <div className="sidebar-menu">
        <div className="sidebar-menu-logo">
          <div className="sidebar-menu-logo-image">
            <img src={INT} alt="INT" />
          </div>
          <div className="sidebar-menu-logo-text">VAULT</div>
          <a className="menuBtn" onClick={sideOpen}>
            {open ? <AiOutlineMenuUnfold /> : <AiOutlineMenuFold />}
          </a>
        </div>

        <div className="sidebar-menu-item">
          <div className="sidebar-menu-item-password-item">
            <div className="sidebar-menu-item-heading">
              <div
                className="sidebar-menu-item-heading-text"
                onClick={menuToggle1}
              >
                <h4>
                  <MdPassword /> <span>Password</span>
                </h4>
                {menuOpen1 ? (
                  <FiMinusCircle className="MenuIcon" />
                ) : (
                  <FiPlusCircle className="MenuIcon" />
                )}
              </div>
            </div>
            {menuOpen1 && (
              <ul>
                <li
                  className={
                    sidebarSelected === "created"
                      ? "sidebar-menu-item-password-item-active"
                      : ""
                  }
                  onClick={() => history.push("/created")}
                >
                  <div className="sidebar-pw-item">
                    <img src={Lock} alt="my password" />
                    <h5>My Passwords</h5>
                  </div>
                </li>
                <li
                  className={
                    sidebarSelected === "shared"
                      ? "sidebar-menu-item-password-item-active"
                      : ""
                  }
                  onClick={() => history.push("/shared")}
                >
                  <div className="sidebar-pw-item">
                    <img src={ShareImg} alt="share" />
                    <h5>Shared</h5>
                  </div>
                </li>
              </ul>
            )}
            {/* </div> */}
          </div>
          <div className="line"></div>
          <div className="sidebar-menu-item-folder">
            <div className="sidebar-menu-item-heading">
              <div
                className="sidebar-menu-item-heading-text"
                onClick={menuToggle2}
              >
                <h4>
                  <MdFolderCopy /> <span>Folder</span>
                </h4>
                {menuOpen2 ? (
                  <FiMinusCircle className="MenuIcon" />
                ) : (
                  <FiPlusCircle className="MenuIcon" />
                )}
              </div>
            </div>

            {menuOpen2 && (
              <div>
                <div
                  className={
                    sidebarSelected === "allFolders"
                      ? "sidebar-menu-item-all-folder sidebar-menu-item-all-folder-active"
                      : "sidebar-menu-item-all-folder"
                  }
                  onClick={() => history.push("/folder_project")}
                >
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <img
                      src={Folder}
                      alt="folder"
                      style={{ width: "20px", height: "20px" }}
                    />
                    <h6>All Folders</h6>
                  </div>
                </div>
                {folderList?.data?.map((item, index) => {
                  return (
                    <div
                      className={
                        sidebarSelected === item?.name
                          ? "sidebar-menu-item-all-folder-list sidebar-menu-item-all-folder-active"
                          : "sidebar-menu-item-all-folder-list"
                      }
                      key={index + "flist"}
                      onClick={() => {
                        setSidebarSelected(item?.name);
                        history.push(`/env_subfolder/${item?._id}`);
                        setFolderDetails(item);
                        setIsShared(false);
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                        }}
                      >
                        {/* <img
                      src={TagCrossGray}
                      alt="folder"
                      style={{ width: "16px", height: "16px" }}
                    /> */}
                        <PiTagSimpleFill
                          style={{ color: item?.color || "#FF99C8" }}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <h6>{item?.name}</h6>
                          <h6
                            style={{
                              marginLeft: "0px",
                              width: "20px",
                            }}
                          >
                            {item?.totalPasswords}
                          </h6>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
          {userData?.admin ? (
            <div
              className={
                sidebarSelected === "user"
                  ? "sidebar-menu-item-heading sidebar-menu-item-all-folder-active "
                  : "sidebar-menu-item-heading"
              }
            >
              <div
                className="sidebar-menu-item-heading-text"
                onClick={() => {
                  history.push("/users");
                  setSidebarSelected("user");
                }}
              >
                <h4>
                  <HiMiniUsers /> <span>Users</span>
                </h4>
                {/* {menuOpen2 ? (
                  <FiMinusCircle className="MenuIcon" />
                ) : (
                  <FiPlusCircle className="MenuIcon" />
                )} */}
              </div>
            </div>
          ) : null}
          {userData?.admin ? (
            <div
              className={
                sidebarSelected === "audit"
                  ? "sidebar-menu-item-heading sidebar-menu-item-all-folder-active "
                  : "sidebar-menu-item-heading"
              }
            >
              <div
                className="sidebar-menu-item-heading-text"
                onClick={() => {
                  history.push("/audit");
                  setSidebarSelected("audit");
                }}
              >
                <h4>
                  <AiOutlineAudit /> <span>Audit Logs</span>
                </h4>
                {/* {menuOpen2 ? (
                  <FiMinusCircle className="MenuIcon" />
                ) : (
                  <FiPlusCircle className="MenuIcon" />
                )} */}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
    // <div className={open ? "sidebar sidebar-open" : "sidebar"}>
    //   <div className="sidebar-menu" style={{ minHeight: "500px" }}>
    //     <ul>
    //       <li className={open ? "hamburger active" : "hamburger"}>
    //         <a onClick={sideOpen}>hamburger</a>
    //       </li>

    //       <li
    //         className={
    //           window.location.pathname === "/password" ||
    //           window.location.pathname.startsWith(
    //             "/viewPasswordHiearchy/"
    //           )
    //             ? "active"
    //             : ""
    //         }
    //       >
    //         <Link
    //           to="/password"
    //           className="password"
    //           title="Password"
    //           onClick={(event) => {
    //             event.preventDefault();
    //           }}
    //         >
    //           <span>Password</span>
    //         </Link>
    //       </li>

    //       <li className="logout">
    //         <Link
    //           to="/login"
    //           onClick={(event) => {
    //             event.preventDefault();
    //             logout();
    //           }}
    //           className="logout"
    //           title="Logout"
    //         >
    //           <span>Logout</span>
    //         </Link>
    //       </li>
    //     </ul>
    //   </div>
    // </div>
  );
}

export default SidebarComponent;
